import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import Loader from "../../components/common/Loader";
import EmptyState from "../../components/common/EmptyState";
import { getRequirement } from "../../api/requirements";
import Button from "../../ui/Button";

export default function RequirementDetail() {
  const { rid } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["requirement", rid],
    queryFn: () => getRequirement(rid),
    enabled: Boolean(rid),
  });

  const breadcrumbItems = [
    { label: "Frameworks", to: "/frameworks" },
    data?.framework_id ? { label: "Framework", to: `/frameworks/${data.framework_id}` } : null,
    { label: data?.code || "Requirement" },
  ].filter(Boolean);

  return (
    <div>
      <Breadcrumbs items={breadcrumbItems} />
      {isLoading && <Loader />}
      {isError && <div>Error: {error?.detail || "Failed to load requirement"}</div>}
      {data && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
            <h1>
              {data.code} - {data.title}
            </h1>
            <div style={{ display: "flex", gap: "8px" }}>
              <Button
                type="button"
                data-testid="edit-requirement"
                onClick={() => navigate(`/frameworks/${data.framework_id}/requirements/${data.id}/edit`)}
                variant="secondary"
              >
                Edit
              </Button>
              <Button type="button" data-testid="map-requirement" onClick={() => navigate(`/requirements/${data.id}/map`)} variant="primary">
                Map Controls
              </Button>
            </div>
          </div>
          <p>
            <strong>Display order:</strong> {data.display_order}
          </p>
          <p>
            <strong>Description:</strong> {data.description || "-"}
          </p>
        </div>
      )}
      {!isLoading && !data && <EmptyState title="Requirement not found" />}
    </div>
  );
}
